export default class Svg {
    constructor() {
        this.fill = null;
        this.stroke = null;
        this.strokeWidth = null;
    }

    fillColor(color) {
        this.fill = color;
        return this;
    }

    strokeColor(color) {
        this.stroke = color;
        return this;
    }

    strokeThickness(size) {
        this.strokeWidth = size;
        return this;
    }

    style(shape) {
        if (this.fill !== null) {
            shape.setAttribute('fill', this.fill);
        }
        if (this.stroke !== null) {
            shape.setAttribute('stroke', this.stroke);
        }
        if (this.strokeWidth !== null) {
            shape.setAttribute('stroke-width', this.strokeWidth);
        }
    }
}
